import pluralize from "pluralize";
import {FiAlertTriangle, FiInfo} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {AlertVariant} from "@/components/alert/Alert.types.ts";
import {ServiceMaintenanceState} from "@/lib/types/checks.ts";

interface ScheduledMaintenanceAlertProps {
  services: ServiceMaintenanceState[];
  scheduleIds: number[];
}

export const ScheduledMaintenanceAlert = ({services, scheduleIds}: ScheduledMaintenanceAlertProps) => {
  const totalSchedules = scheduleIds.length;
  const totalServices = services.length;

  if (totalSchedules === 0) {
    return false;
  }

  const alreadyLinkedCount = scheduleIds.filter((id) =>
    services.every((s) => s.maintenance_schedule_ids.includes(id))
  ).length;
  const newSchedulesCount = totalSchedules - alreadyLinkedCount;

  let variant: AlertVariant;
  let children: string;

  if (newSchedulesCount === 0) {
    variant = "default";
    children = "All selected schedules are already linked to all selected checks. No changes to apply.";
  } else if (alreadyLinkedCount === 0) {
    variant = "maintenance";
    children = `Schedules will be linked to all of the selected checks (${totalServices}).`;
  } else {
    variant = "maintenance";
    children = `${pluralize("schedule", newSchedulesCount, true)} will be linked to all selected checks (${totalServices}). Already linked schedules will be skipped.`;
  }

  const header = `${pluralize("schedule", totalSchedules, true)} selected`;

  return (
    <Alert
      className="mt-4"
      size={"small"}
      callout={header}
      variant={variant}
      icon={variant === "maintenance" ? FiAlertTriangle : FiInfo}
    >
      {children}
    </Alert>
  );
};
